import type { AnalyticsControllerType } from './AnalyticsController.types';

class AnalyticsController implements AnalyticsControllerType {
  private controllers: Array<Partial<AnalyticsControllerType>> = [];

  register = (controllers: Array<Partial<AnalyticsControllerType>>) =>
    (this.controllers = controllers);

  identifyUser: AnalyticsControllerType['identifyUser'] = (...params) =>
    this.controllers.forEach((controller) => controller.identifyUser?.(...params));

  resetUser: AnalyticsControllerType['resetUser'] = (...params) =>
    this.controllers.forEach((controller) => controller.resetUser?.(...params));

  pageView: AnalyticsControllerType['pageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.pageView?.(...params));

  loginPageView: AnalyticsControllerType['loginPageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.loginPageView?.(...params));

  loginAttempted: AnalyticsControllerType['loginAttempted'] = (...params) =>
    this.controllers.forEach((controller) => controller.loginAttempted?.(...params));

  signupPageView: AnalyticsControllerType['signupPageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.signupPageView?.(...params));

  signupAttempted: AnalyticsControllerType['signupAttempted'] = (...params) =>
    this.controllers.forEach((controller) => controller.signupAttempted?.(...params));

  mainStudyCycleAttempted: AnalyticsControllerType['mainStudyCycleAttempted'] = (...params) =>
    this.controllers.forEach((controller) => controller.mainStudyCycleAttempted?.(...params));

  mainStudyCycleCompleted: AnalyticsControllerType['mainStudyCycleCompleted'] = (...params) =>
    this.controllers.forEach((controller) => controller.mainStudyCycleCompleted?.(...params));

  studyCyclePageView: AnalyticsControllerType['studyCyclePageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.studyCyclePageView?.(...params));

  surveyCycleReadyToReview: AnalyticsControllerType['surveyCycleReadyToReview'] = (...params) =>
    this.controllers.forEach((controller) => controller.surveyCycleReadyToReview?.(...params));

  surveyCycleAttempted: AnalyticsControllerType['surveyCycleAttempted'] = (...params) =>
    this.controllers.forEach((controller) => controller.surveyCycleAttempted?.(...params));

  surveyCycleCompleted: AnalyticsControllerType['surveyCycleCompleted'] = (...params) =>
    this.controllers.forEach((controller) => controller.surveyCycleCompleted?.(...params));

  performanceScreenPageView: AnalyticsControllerType['performanceScreenPageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.performanceScreenPageView?.(...params));

  performanceScreenWhatIsTKL: AnalyticsControllerType['performanceScreenWhatIsTKL'] = (...params) =>
    this.controllers.forEach((controller) => controller.performanceScreenWhatIsTKL?.(...params));

  review10moreAttempted: AnalyticsControllerType['review10moreAttempted'] = (...params) =>
    this.controllers.forEach((controller) => controller.review10moreAttempted?.(...params));

  review10moreCompleted: AnalyticsControllerType['review10moreCompleted'] = (...params) =>
    this.controllers.forEach((controller) => controller.review10moreCompleted?.(...params));

  libraryModePageView: AnalyticsControllerType['libraryModePageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.libraryModePageView?.(...params));

  libraryModeSelectDeck: AnalyticsControllerType['libraryModeSelectDeck'] = (...params) =>
    this.controllers.forEach((controller) => controller.libraryModeSelectDeck?.(...params));

  libraryModeAttempted: AnalyticsControllerType['libraryModeAttempted'] = (...params) =>
    this.controllers.forEach((controller) => controller.libraryModeAttempted?.(...params));

  tourPageView: AnalyticsControllerType['tourPageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.tourPageView?.(...params));

  feedbackPageView: AnalyticsControllerType['feedbackPageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.feedbackPageView?.(...params));

  feedbackSubmit: AnalyticsControllerType['feedbackSubmit'] = (...params) =>
    this.controllers.forEach((controller) => controller.feedbackSubmit?.(...params));

  preferencesPageView: AnalyticsControllerType['preferencesPageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.preferencesPageView?.(...params));

  preferencesSubmit: AnalyticsControllerType['preferencesSubmit'] = (...params) =>
    this.controllers.forEach((controller) => controller.preferencesSubmit?.(...params));

  afterLoginResetPasswordPageView: AnalyticsControllerType['afterLoginResetPasswordPageView'] = (
    ...params
  ) =>
    this.controllers.forEach((controller) =>
      controller.afterLoginResetPasswordPageView?.(...params)
    );

  resetPasswordSubmit: AnalyticsControllerType['resetPasswordSubmit'] = (...params) =>
    this.controllers.forEach((controller) => controller.resetPasswordSubmit?.(...params));

  logoutPageView: AnalyticsControllerType['logoutPageView'] = (...params) =>
    this.controllers.forEach((controller) => controller.logoutPageView?.(...params));

  beforeLoginResetPasswordPageView: AnalyticsControllerType['beforeLoginResetPasswordPageView'] = (
    ...params
  ) =>
    this.controllers.forEach((controller) =>
      controller.beforeLoginResetPasswordPageView?.(...params)
    );

  beforeLoginResetPasswordSubmit: AnalyticsControllerType['beforeLoginResetPasswordSubmit'] = (
    ...params
  ) =>
    this.controllers.forEach((controller) =>
      controller.beforeLoginResetPasswordSubmit?.(...params)
    );
}

export const analytics = new AnalyticsController();
